import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f4ea46c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onUpdate:modelValue"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" * 10^ ")
const _hoisted_5 = ["onUpdate:modelValue"]

import { inject, ref, computed, onMounted, watch } from 'vue';
import { CircuitConfig, circuitConfigInjectionKey, defaultCircuits } from './CircuitSelector/CircuitManager';
import { CNode, extractParams } from './CircuitSelector/CircuitAnalyzer';
import { PlotData } from '@/components/Impedance';

import {Complex} from "@/components/Utility/complex";

interface Emits{
    (e: "emit", v: PlotData[]): void
}
/* eslint-disable-next-line */

export default /*#__PURE__*/_defineComponent({
  __name: 'ParameterSlider',
  emits: ["emit"],
  setup(__props, { emit }: { emit: ({
    (e: "emit", v: PlotData[]): void
}), expose: any, slots: any, attrs: any }) {

const circuits = inject(circuitConfigInjectionKey, defaultCircuits).circuits;
const circuit = computed(()=>circuits.find(c=>c.selected));
const initParams = (circuit:CircuitConfig|undefined)=>{
    return (circuit)?
        extractParams(circuit.nodes).map(name=> {return {
            name: name,
            value: 1.0,
            exponent: 1.0
        }}) : [];
};

let params = ref(initParams(circuit.value));
const correct = function(e: Event){
    const val = (e.currentTarget as HTMLInputElement).value;
    let val_num = Math.round(parseFloat(val));
    if(val_num < -6 || val_num > 6){
        val_num = 0;
    }
    (e.currentTarget as HTMLInputElement).value = val_num.toString();
}

watch(circuit, ()=>{
    params.value = initParams(circuit.value);
    emit("emit", calc_data.value);
});

const calc_impedance = (node: CNode|null|undefined, freq: number):Complex=>{
    if(!node){
        return new Complex(0,0);
    }
    if(node.type === "operator"){
        switch(node.name){
            case "-":
                return Complex.add(calc_impedance(node.left, freq), calc_impedance(node.right, freq));
            case "/":
                return Complex.inv(Complex.add(Complex.inv(calc_impedance(node.left, freq)), Complex.inv(calc_impedance(node.right, freq))));
            default:
                throw new Error("Unexpected operator type");
        }
    }else{                
        const p = params.value.find(p=>p.name===node.name);
        if(!p){
            throw new Error("not found node");
        }
        switch(node.name.substring(0,1)){
            case "R":
                return new Complex(p.value * Math.pow(10, p.exponent), 0);
            case "C":
                return Complex.inv(new Complex(0, 2 * Math.PI * freq * p.value * Math.pow(10, p.exponent)));
            case "L":
                return new Complex(0, 2 * Math.PI * freq * p.value * Math.pow(10, p.exponent));
            default:
                throw new Error("Unexpected node type");
        }
    }
}

const calc_data = computed(()=>{
    const f_arr = [];
    for(let i=0; i<101; ++i){
        f_arr.push(4.0 * Math.pow(10, 6 * i/100 - 2));
    }

    const z_arr:Complex[] = f_arr.map(f=>calc_impedance(circuit?.value?.nodes, f));
    const rs_arr:number[] = z_arr.map(z=>z.real);
    const x_arr:number[] = z_arr.map(z=>z.imag);

    return [{
        name: "Simulated",
        f: f_arr,
        rs: rs_arr,
        x: x_arr
    } as PlotData];
});




const onChange = ()=>emit("emit", calc_data.value);
onMounted(()=>{
    emit("emit", calc_data.value);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(params), (param, index) => {
      return (_openBlock(), _createElementBlock("tr", {
        class: "row",
        key: index,
        onChange: onChange
      }, [
        _createElementVNode("td", null, _toDisplayString(param.name), 1),
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": ($event: any) => ((param.value) = $event)
          }, null, 8, _hoisted_1), [
            [_vModelText, param.value]
          ]),
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            type: "range",
            min: "1.000",
            max: "9.999",
            step: "0.001",
            "onUpdate:modelValue": ($event: any) => ((param.value) = $event)
          }, null, 8, _hoisted_3), [
            [_vModelText, param.value]
          ])
        ]),
        _createElementVNode("td", null, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "-6",
            max: "6",
            "onUpdate:modelValue": ($event: any) => ((param.exponent) = $event),
            onKeydown: ($event: any) => (null),
            onChange: correct
          }, null, 40, _hoisted_5), [
            [_vModelText, param.exponent]
          ])
        ])
      ], 32))
    }), 128))
  ]))
}
}

})